import { FulfilmentTypeEnum } from "@enums/fulfilmentType.enum";
import { MaterialPurpose } from "@enums/materialPurpose.enum";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { Model } from "@interfaces/model.interface";
import { Supplier } from "@interfaces/models/supplier.interface";

export interface PurchaseLog extends Model {
	coC: number;
	cocNo: string;
	completedBy: number;
	contactEmail: string;
	contactName: string;
	contractId?: number;
	correctDelivery: boolean;
	datePaid?: Date;
	deliveryNote: number;
	dueDate: Date;
	email: string;
	freightAmount: number;
	fulfilmentType: FulfilmentTypeEnum;
	lineItems: string; // JSON string
	materialPurpose: MaterialPurpose;
	orderReceived: boolean;
	packedIn: string;
	paid: boolean;
	partId?: number;
	paymentDueDate: Date;
	paymentTermId?: number;
	printerCode: string;
	projectId: number;
	purchaseType: PurchaseTypeEnum
	siteId?: number;
	specialInstructions: string;
	stateOfDelivery: number;
	supplier: Supplier;
	supplierContactId: number;
	supplierId: number;
	supportingDocuments: string;
	totalCost: number;
	totalQuantity: number;
	userProfileId: number;
	weekNo: number;
	weight:number;
	workReferenceNo: string;
}

export class PurchaseLog implements PurchaseLog {
	cocNo = "";
	contactEmail = "";
	contactName = "";
	correctDelivery = false;
	dueDate = new Date();
	email = "";
	fulfilmentType = FulfilmentTypeEnum.Delivery;
	lineItems = ""; // JSON string
	materialPurpose = MaterialPurpose.Other;
	orderReceived = false;
	printerCode = "";
	purchaseType = PurchaseTypeEnum.Consumables;
	supportingDocuments = "";
	totalCost = 0;
	totalQuantity = 0;
	weekNo = 0;
	workReferenceNo = "";

	constructor(data?: Partial<PurchaseLog>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}